import { RelatesTo, Sentiment } from "./commands";
import { PaginationFilters } from "../../../common/types/Paginated";

export type UserInfo = {
  id: string;
  firstName: string;
  lastName: string;
};

export enum FeedbackType {
  CUSTOMER_FEEDBACK_WORKTIMEENTRY = "CUSTOMER_FEEDBACK_WORKTIMEENTRY",
  TALENT_FEEDBACK_WORKTIMEENTRY = "TALENT_FEEDBACK_WORKTIMEENTRY",
  CUSTOMER_FEEDBACK_TALENT = "CUSTOMER_FEEDBACK_TALENT",
  TALENT_FEEDBACK_WORKLOCATION = "TALENT_FEEDBACK_WORKLOCATION",
}

export type FeedbackWorkTimeEntry = {
  id: string;
  start: EpochTimeStamp;
  end: EpochTimeStamp;
  workTitleId: string;
};

export interface Feedback {
  id: string;
  targetAggregateId: string; // Depends on feedback type
  reporter: UserInfo; // Talent, Expert, Customer
  type: FeedbackType;
  workLocationId?: string;
  workLocationName?: string;
  worktimeEntry?: FeedbackWorkTimeEntry;
  talent: UserInfo;
  comment?: string;
  rating?: number;
  createdAt: EpochTimeStamp;
  sentiment?: Sentiment;
  relatesTo?: RelatesTo;
  ackByUserId?: string; // can be "system-user" or actual "expert-id"
}

export interface UnacknowledgedFeedbacksCount extends PaginationFilters {
  notAcknowledged: true;
}
